import * as Yup from "yup";

const sqlInjectionRegex = /('|"|;|\b(--|\|\||\/\*|\*\/|EXEC(\s|\+)+(SP|XP)|DECLARE\s+[@#]|SELECT\s+.*\s+FROM|INSERT\s+INTO|DELETE\s+FROM|DROP\s+TABLE|UPDATE\s+.*\s+SET|UNION\s+SELECT))\b/i;
const emailRules = /^(?!\.)(?!.*\.\.)[A-Za-z0-9._%+-]+@(?!(?:[-]))[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,}$/;

const noSQLInjection = (fieldName) =>
    Yup.string().test(
        'no-sql-injection',
        `${fieldName} contains potentially dangerous characters`,
        value => {
            // Allow null or empty values
            if (value === null || value === undefined || value.trim() === '') {
                return true;
            }

            // Reject if SQL injection pattern matches
            return !sqlInjectionRegex.test(value);
        }
    );


const identitySchema = Yup.object().shape({
    key: Yup.string(),
    value: Yup.string()
});

export const addCompanySchema = Yup.object().shape({
    companyName: Yup.string().required("Please Enter Customer Name").concat(noSQLInjection('Company Name')),
    companyCode: Yup.string().required("Please Enter Customer Code").concat(noSQLInjection('Company Code')),
    customerType: Yup.string().required("Please select Customer Type").concat(noSQLInjection('Customer Type')),
    entityType: Yup.string().required("Please select Entity Type").concat(noSQLInjection('Entity Type')),
    industryType: Yup.string().required("Please select Industry Type").concat(noSQLInjection('Industry Type')),
    address: Yup.string().nullable()
        .required('Please Enter Address')
        .test(
            'no-sql-injection',
            'Address contains potentially dangerous characters',
            value => {
                if (!value) return true;
                return !sqlInjectionRegex.test(value);
            }
        ),
    GSTnumber: Yup.string()
        .transform(value => (value === '' ? null : value))
        .notRequired()
        .matches(
            /^([0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1})?$/,
            'Invalid Tax number format'
        ),
    city: Yup.string().nullable()
        .required('Please selected City').test(
            'no-sql-injection',
            'City contains potentially dangerous characters',
            value => {
                if (!value) return true;
                return !sqlInjectionRegex.test(value);
            }
        ),
    zipcode: Yup.string().nullable().notRequired().test(
        'no-sql-injection',
        'Zipcode contains potentially dangerous characters',
        value => {
            if (!value) return true;
            return !sqlInjectionRegex.test(value);
        }
    ),
    email: Yup.string().required("Email required")
        .max(100, 'Email must be 100 characters or less')
        .matches(/^\S+$/, 'Email must not contain spaces')
        .matches(/^[\x00-\x7F]+$/, 'Email must be ASCII only')
        .matches(/^[^<>]*$/, 'Invalid characters detected')
        .matches(emailRules, 'Please enter a valid email address')
        .concat(noSQLInjection('Contact Email')),
    contactName: Yup.string().required("Please Enter Your contact Name").concat(noSQLInjection('Contact Name')),
    phoneNumber: Yup
        .string()
        .required("Phone number is required")
        .matches(/^\d{10}$/, "Please enter valid phone number"),
    keyAccountManager: Yup.string().required("Please select manager account"),
    salesEmployee: Yup.string().required("Please select sales employee"),
    identities: Yup.array().of(identitySchema),
});